import { Avatar, Grid } from "@mui/material";
import { APIPaths } from "@unit/apis";
import { FontColor } from "@unit/styles";
import { SVGIconBell, SVGIconHeart, SVGIconHome, SVGIconInfluencerTicket } from "@unit/svgs";
import { convertToWebP } from "@unit/utility";
import { useAtom } from "jotai";
import { useRouter } from "next/router";
import React from "react";
import { useQuery } from "react-query";

import FooterItem from "@/components/layout/footer/FooterItem";
import { useInfluencerTicketApi } from "@/custom-hooks/apis/use-influencer-ticlket-api";
import {
  homePath,
  loginPath,
  myTicketsFavoritePath,
  myPagePath,
  influencerTicketPath,
  notificationPath,
} from "@/global-state/influencer-app-path";
import { authUserAtom, unreadInfluencerTicketIdListAtom, unreadNotificationCountAtom } from "@/global-state/jotai-atom";
import { QueryKeys } from "@/global-state/react-query-keys";

const HomeNavFooter: React.FC = () => {
  const [authUser] = useAtom(authUserAtom);
  const { fetchInfluencerTicketList } = useInfluencerTicketApi();
  const [unreadInfluencerTicketIdList] = useAtom(unreadInfluencerTicketIdListAtom);
  const router = useRouter();
  const onClickMenu = async (path: string) => await router.push(path);

  const influencerTicketQuery: APIPaths["/app/influencer-ticket/list"]["get"]["parameters"]["query"] = {
    offset: 0,
    limit: 500,
    emptyPosts: "true",
    emptyRatings: "true",
    emptySchedules: "true",
    status: "none,denied,canceled,requesting,offering,active,scheduling,scheduled,used,checked,rated,done",
  };

  const { data: dataInfluencerTicketList } = useQuery(
    [QueryKeys.fetchInfluencerTicketList, influencerTicketQuery],
    () => fetchInfluencerTicketList(influencerTicketQuery),
  );

  const influencerTicketIdList = dataInfluencerTicketList?.objects.map((data) => data.id).filter(Boolean) || [];
  const unreadCount: number = unreadInfluencerTicketIdList.filter((id) => influencerTicketIdList.includes(id)).length;
  const [unreadNotificationCount] = useAtom(unreadNotificationCountAtom);

  return (
    <Grid px={2} container direction={"row"} justifyContent={"space-evenly"} alignItems={"center"}>
      {/* ホーム */}
      <Grid item xs onClick={() => onClickMenu(homePath)}>
        <FooterItem label="ホーム" isActive={router.pathname === homePath}>
          <SVGIconHome fill={router.pathname === homePath ? FontColor.basic : FontColor.inactive} />
        </FooterItem>
      </Grid>

      {/* やりとり */}
      <Grid item xs onClick={() => onClickMenu(influencerTicketPath)}>
        <FooterItem label="やりとり" isActive={router.pathname === influencerTicketPath} badgeContent={unreadCount}>
          <SVGIconInfluencerTicket
            fill={router.pathname === influencerTicketPath ? FontColor.basic : FontColor.inactive}
          />
        </FooterItem>
      </Grid>

      {/* お気に入り */}
      <Grid item xs onClick={() => onClickMenu(myTicketsFavoritePath)}>
        <FooterItem label="お気に入り" isActive={router.pathname === myTicketsFavoritePath}>
          <SVGIconHeart fill={router.pathname === myTicketsFavoritePath ? FontColor.basic : FontColor.inactive} />
        </FooterItem>
      </Grid>

      {/* お知らせ */}
      <Grid item xs onClick={() => onClickMenu(notificationPath)}>
        <FooterItem
          label="お知らせ"
          isActive={router.pathname === notificationPath}
          badgeContent={unreadNotificationCount}
        >
          <SVGIconBell fill={router.pathname === notificationPath ? FontColor.basic : FontColor.inactive} />
        </FooterItem>
      </Grid>

      {/* マイページ */}
      <Grid item xs onClick={() => onClickMenu(authUser ? myPagePath : loginPath)}>
        <FooterItem label="マイページ" isActive={router.pathname === myPagePath}>
          <Avatar
            src={authUser?.avatarUrl ? convertToWebP(authUser?.avatarUrl) : ""}
            sx={{ width: "26px", height: "26px" }}
          />
        </FooterItem>
      </Grid>
    </Grid>
  );
};
export default React.memo(HomeNavFooter);
